// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellAndComment16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-and-comment': IconBellAndComment;
    }
}

/**
 * The icon component for the 'bellAndComment' icon
 */
export class IconBellAndComment extends Icon {
    public constructor() {
        super(bellAndComment16X16);
    }
}

registerIcon('icon-bell-and-comment', IconBellAndComment);
export const iconBellAndCommentTag = 'nimble-icon-bell-and-comment';
